import { apiConstants } from '../constants/apiConstants'
import { httpRequest } from './httpRequest'

export async function fetchMetaDataOfFileOrFolder(path) {
  if (path === '' || path === '/') {
    return false
  }
  const params = { getMetadata: true }
  return await httpRequest('POST', path, apiConstants.SearchURLSuffix, params)
}

export async function createFolder(path) {
  return await httpRequest('POST', path, apiConstants.CreateFolderURLSuffix, {})
}

export async function moveOrRenameFileOrFolder(sourcePath, destinationPath) {
  const params = { destinationFile: destinationPath }
  return await httpRequest('POST', sourcePath, apiConstants.Move, params)
}

export async function copyFileOrFolder(sourcePath, destinationPath) {
  const params = { destinationFile: destinationPath }
  return await httpRequest('POST', sourcePath, apiConstants.Copy, params)
}

export async function fetchFolderData(path, params) {
  return await httpRequest('POST', path, apiConstants.SearchURLSuffix, params)
}

export async function logoutUser() {
  return await httpRequest('GET', '', apiConstants.Logout, {})
}

export async function sendShareNotificationEmail(params) {
  return await httpRequest(
    'POST',
    '',
    apiConstants.ResendFileShareEmail,
    params,
  )
}

export async function fetchOrUpdateShareeDetails(method, path, params) {
  return await httpRequest(method, path, apiConstants.Share, params)
}

export async function deleteFileOrFolder(path) {
  return await httpRequest('DELETE', path, '', '')
}

export async function fetchFileHistory(path, params) {
  return await httpRequest('POST', path, apiConstants.Track, params)
}

export async function fetchDiskUsage(path, params) {
  return await httpRequest('GET', path, apiConstants.DiskUsage, params)
}

/* Share permission request api wrappers  */
export const sharePermissionAPI = (method, path, params, auth = true) => {
  return httpRequest(
    method,
    path,
    apiConstants.SharePermissionRequest,
    params,
    auth,
  )
}

export default {
  fetchMetaDataOfFileOrFolder,
  createFolder,
  moveOrRenameFileOrFolder,
  copyFileOrFolder,
  fetchFolderData,
  logoutUser,
  sendShareNotificationEmail,
  fetchOrUpdateShareeDetails,
  deleteFileOrFolder,
  fetchFileHistory,
  fetchDiskUsage,
  sharePermissionAPI,
}
